import React from 'react';
import AboutusSection from './AboutusSection/AboutusSection';
import WhoWeWorkWithSection from './WhoWeWorkWithSection/WhoWeWorkWithSection';
import WhyModli3DSection from './WhyModli3DSection/WhyModli3DSection';
import TheFirstStepSection from './TheFirstStepSection/TheFirstStepSection';
import PrintingServiceSection from './PrintingServiceSection/PrintingServiceSection';
import WhatweOfferView from './WhatWeOfferView/WhatweOfferView';

const AboutUs: React.FC = () => {
  return (
    <>
      <article id="post-18103" className="post_item_single post_type_page post-18103 page type-page status-publish hentry">
        <div className="post_content entry-content">
          <div data-elementor-type="wp-page" data-elementor-id="18103" className="elementor elementor-18103">
            <AboutusSection />
            <div data-elementor-type="wp-page" data-elementor-id="18406" className="elementor elementor-18406">
              <WhatweOfferView />
            </div>
            <WhoWeWorkWithSection />
            <WhyModli3DSection />
            <div data-elementor-type="wp-page" data-elementor-id="19064" className="elementor elementor-19064">
              <TheFirstStepSection />
              <PrintingServiceSection />
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default AboutUs;